import { tw } from '@/utils/tw';
import BaseBlipTheme from 'base/components/Blip/theme';

const Blip = tw.theme({
  extend: BaseBlipTheme,
  base: `bg-logga-600 before:bg-logga-600 after:bg-logga-600`,
});

export default Blip;
